import * as THREE from 'three';

// The shipped Kenney castle GLBs reference a palette texture that was not included in the
// source export. Production terrain replaces those materials after loading, so a neutral
// pixel is the correct deterministic fallback and avoids four failed texture requests.
const NEUTRAL_PIXEL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAANSURBVBhXY/j///9/AAn7A/0FQ0XKAAAAAElFTkSuQmCC';

export function createModelLoadingManager(): THREE.LoadingManager {
  const manager = new THREE.LoadingManager();
  manager.setURLModifier((url) =>
    /(?:^|\/)Textures\/colormap\.png(?:[?#].*)?$/i.test(url) ? NEUTRAL_PIXEL : url,
  );
  return manager;
}
